import React from 'react';
import {
  //BellFilled,
  ExportOutlined, UserOutlined,
} from '@ant-design/icons';
import { useHandleClick } from '@/components/UserOptions/hooks';
import { USER_ACTION_TYPE } from '@/components/UserOptions/constants';
import Home6LineIcon from 'remixicon-react/Home6LineIcon';
import SurveyLineIcon from 'remixicon-react/SurveyLineIcon';
import BubbleChartLineIcon from 'remixicon-react/BubbleChartLineIcon';
import TaskLineIcon from 'remixicon-react/TaskLineIcon';
import FlagLineIcon from 'remixicon-react/FlagLineIcon';
import FolderInfoLineIcon from 'remixicon-react/FolderInfoLineIcon';
import UserSettingsLineIcon from 'remixicon-react/UserSettingsLineIcon';
import CalendarTodoLineIcon from 'remixicon-react/CalendarTodoLineIcon';
import FileTextLineIcon from 'remixicon-react/FileTextLineIcon';
import { ReactComponent as Kitchen } from '@/assets/images/kitchen-icon.svg';
import { ReactComponent as Pool } from '@/assets/images/pool-menu-icon.svg';
import { ReactComponent as Legionella } from '@/assets/images/legionella-menu-icon.svg';
import { ReactComponent as Others } from '@/assets/images/others-menu-icon.svg';
import { ReactComponent as FlaskLineIcon } from '@/assets/images/lab-data-menu.svg';
import { ReactComponent as Food } from '@/assets/images/food-menu-icon.svg';
import QuestionnaireLineIcon from 'remixicon-react/QuestionnaireLineIcon';

/**
 * Navigation define all the routes and link that
 * will be render in the sidebar or navbar(depending of the layout)
 *
 * It can be an
 * {Array} Use array when yo have group sections, like Main, Admin , etc
 * Ex: [{title:'name', menu:[...],}, ....]
 *
 * {Object} Use object when yo don't have section , it is just one,
 * Ex: {menu: [.....]}
 * */
export const navigation = {
  menu: [
    {
      title: 'home',
      exact: 'true',
      link: '/home/auditor',
      permissions: ['AUDIT:READ'],
      isAuditor: true,
      icon: <Home6LineIcon className="antd-icon"/>,
    },
    {
      title: 'home',
      exact: 'true',
      link: '/home/client',
      permissions: ['AUDIT:READ', 'REGISTER:READ', 'ANALYTICS:READ'],
      isClient: true,
      icon: <Home6LineIcon className="antd-icon"/>,
    },
    {
      title: 'registers',
      exact: 'true',
      link: '/client-registers',
      permissions: ['REGISTER:READ'],
      isClient: true,
      selectable: true,
      icon: <FileTextLineIcon className="antd-icon"/>,
      menu: [
        {
          title: 'foodSafety',
          exact: 'true',
          link: '/client-registers/kitchen',
          permissions: ['REGISTER:READ'],
          icon: <Kitchen className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
        {
          title: 'pool',
          exact: 'true',
          link: '/client-registers/pool',
          permissions: ['REGISTER:READ'],
          icon: <Pool className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
        {
          title: 'legionella',
          exact: 'true',
          link: '/client-registers/legionella',
          permissions: ['REGISTER:READ'],
          icon: <Legionella className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
        {
          title: 'others',
          exact: 'true',
          link: '/client-registers/others',
          permissions: ['REGISTER:READ'],
          icon: <Others className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
      ]
    },
    {
      title: 'audits',
      exact: 'true',
      link: '/client-audits',
      permissions: ['AUDIT:READ'],
      isClient: true,
      icon: <SurveyLineIcon className="antd-icon"/>,
      menu: [
        {
          title: 'resume',
          exact: 'true',
          link: '/client-audits/resume',
          permissions: ['AUDIT:READ'],
          icon: <FolderInfoLineIcon className="antd-icon" style={{ height: '1.2rem'}}/>,
        },
        {
          title: 'madeAudits',
          exact: 'true',
          link: '/client-audits/audits',
          permissions: ['AUDIT:READ'],
          icon: <TaskLineIcon className="antd-icon" style={{ height: '1.2rem'}}/>,
        },
      ]
    },
    {
      title: 'labData',
      exact: 'true',
      link: '/lab-data',
      permissions: ['LAB_DATA_VIEW', 'LAB_DATA_WRITE', 'LAB_DATA_ISSUES_VIEW', 'LAB_DATA_ISSUES_WRITE', 'REQUEST_VIEW', 'SAMPLE_TYPE_VIEW', 'CATEGORY_VIEW'],
      isClient: true,
      selectable: true,
      icon: <FlaskLineIcon className="antd-icon" />,
      menu: [
        {
          title: 'foodSafety',
          exact: 'true',
          link: '/lab-data/food',
          permissions: ['LAB_DATA_VIEW', 'LAB_DATA_WRITE', 'LAB_DATA_ISSUES_VIEW', 'LAB_DATA_ISSUES_WRITE', 'REQUEST_VIEW', 'SAMPLE_TYPE_VIEW', 'CATEGORY_VIEW'],
          icon: <Food className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
        {
          title: 'pool',
          exact: 'true',
          link: '/lab-data/pool',
          permissions: ['LAB_DATA_VIEW', 'LAB_DATA_WRITE', 'LAB_DATA_ISSUES_VIEW', 'LAB_DATA_ISSUES_WRITE', 'REQUEST_VIEW', 'SAMPLE_TYPE_VIEW', 'CATEGORY_VIEW'],
          icon: <Pool className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
        {
          title: 'legionella',
          exact: 'true',
          link: '/lab-data/legionella',
          permissions: ['LAB_DATA_VIEW', 'LAB_DATA_WRITE', 'LAB_DATA_ISSUES_VIEW', 'LAB_DATA_ISSUES_WRITE', 'REQUEST_VIEW', 'SAMPLE_TYPE_VIEW', 'CATEGORY_VIEW'],
          icon: <Legionella className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
        {
          title: 'others',
          exact: 'true',
          link: '/lab-data/others',
          permissions: ['LAB_DATA_VIEW', 'LAB_DATA_WRITE', 'LAB_DATA_ISSUES_VIEW', 'LAB_DATA_ISSUES_WRITE', 'REQUEST_VIEW', 'SAMPLE_TYPE_VIEW', 'CATEGORY_VIEW'],
          icon: <Others className="antd-icon" style={{ height: '1.2rem', stroke: 'black'}}/>,
        },
      ]
    },
    {
      title: 'incidents',
      exact: 'true',
      link: '/incidents',
      permissions: ['AUDIT:READ', 'ISSUE:READ', 'LAB_DATA_VIEW', 'LAB_DATA_ISSUES_VIEW', 'REGISTER:READ'],
      isClient: true,
      icon: <FlagLineIcon className="antd-icon"/>
    },
    {
      title: 'documentation',
      exact: 'true',
      link: '/documentation',
      permissions: ['GOOGLE_DRIVE:READ'],
      isClient: true,
      icon: <FolderInfoLineIcon className="antd-icon"/>
    },
    {
      title: 'users',
      exact: 'true',
      link: '/users',
      permissions: ['USER:MANAGEMENT'],
      isClient: true,
      includeAdmin: false,
      icon: <UserSettingsLineIcon className="antd-icon"/>,
      menu: [
        {
          title: 'users',
          exact: 'true',
          link: '/users/users',
          includeAdmin: false,
          permissions: ['USER:MANAGEMENT'],
        },
        // {
        //   title: 'rolesAndPermissions',
        //   exact: 'true',
        //   link: '/users/roles-and-permissions',
        //   permissions: ['USER:MANAGEMENT', 'SPACE:ADMIN', 'SPACE:OWNER'],
        // }
      ]
    },
    /*{
      title: 'analytics',
      exact: 'true',
      link: '/analytics/client',
      permissions: ['ANALYTICS:READ'],
      isClient: true,
      icon: <BubbleChartLineIcon className="antd-icon"/>
    },*/
    {
      title: 'statistics',
      exact: 'true',
      link: '/analytics/client',
      permissions: ['ANALYTICS:READ', 'REGISTER:READ', 'AUDIT:READ'],
      isClient: true,
      icon: <BubbleChartLineIcon className="antd-icon"/>
    },
    {
      title: 'visitsCalendar',
      exact: 'true',
      link: '/calendar',
      isAuditor: true,
      permissions: ['AUDIT:READ'],
      icon: <CalendarTodoLineIcon className="antd-icon"/>
    },
    {
      title: 'registers',
      exact: 'true',
      link: '/registers',
      permissions: ['REGISTER:READ'],
      isAuditor: true,
      icon: <FileTextLineIcon className="antd-icon"/>,
      menu: [
        {
          title: 'management',
          exact: 'true',
          link: '/registers/management',
          permissions: ['REGISTER:READ', 'REGISTER:WRITE'],
        },
        {
          title: 'inspection',
          exact: 'true',
          link: '/registers/inspection',
          permissions: ['REGISTER:READ'],
        }
      ]
    },
    {
      title: 'audits',
      exact: 'true',
      link: '/auditor/audits',
      isAuditor: true,
      permissions: ['AUDIT:READ'],
      icon: <SurveyLineIcon className="antd-icon"/>// <Briefcase2LineIcon className="antd-icon"/>
    },
    // {
    //   title: 'documentation',
    //   exact: 'true',
    //   link: '/auditor-documentation',
    //   permissions: ['USER', 'AUDIT:READ'],
    //   isAuditor: true,
    //   icon: <FolderInfoLineIcon className="antd-icon"/>
    // },
    {
      title: 'analytics',
      exact: 'false',
      link: '/analytics/auditor',
      permissions: ['ANALYTICS:READ'],
      isAuditor: true,
      icon: <BubbleChartLineIcon className="antd-icon"/>
    },
    {
      title: 'faqView',
      // exact: 'true',
      link: '/faqs-view',
      isAuditor: true,
      // permissions: ['AUDIT:READ', 'SOCIAL_REASON:READ', 'PROFILE-WORKER:READ', 'ACTIVITY:READ', 'BILLING-METHOD:READ', 'ENTERPRISE:READ', 'CATEGORY:READ', 'TEMPLATES:READ', 'ENTERPRISE:READ'],
      icon: <QuestionnaireLineIcon className="antd-icon"/>,
    },
    {
      title: 'faqView',
      // exact: 'true',
      link: '/faqs-view-client',
      isClient: true,
      // permissions: ['AUDIT:READ', 'SOCIAL_REASON:READ', 'PROFILE-WORKER:READ', 'ACTIVITY:READ', 'BILLING-METHOD:READ', 'ENTERPRISE:READ', 'CATEGORY:READ', 'TEMPLATES:READ', 'ENTERPRISE:READ'],
      icon: <QuestionnaireLineIcon className="antd-icon"/>,
    },
    {
      title: 'documentation',
      exact: 'true',
      link: '/auditor-docs/directory-list',
      isAuditor: true,
      permissions: ['GOOGLE_DRIVE:WRITE'],
      icon: <FolderInfoLineIcon className="antd-icon"/>
    },
  ]
};

export const userOptions = {
  // options: [
  //   {
  //     title: 'notifications',
  //     action: 'NOTIFICATIONS',
  //     icon: <BellFilled/>
  //   }
  // ],
  userActions: {
    viewType: USER_ACTION_TYPE.POPUP,
    showInfo: true,
    options: [
      {
        divider: true
      },
      {
        title: 'profile',
        action: 'PROFILE',
        icon: <UserOutlined/>,
      },
      {
        divider: true
      },
      {
        title: 'logout',
        action: 'LOGOUT',
        icon: <ExportOutlined/>,
      }
    ],
  },
  useHandleClick
};
